import React, { useState } from 'react';
import '../../styles/Membership.css';
import '../../styles/Events.css';
import { FaChevronRight } from 'react-icons/fa';

export default function MembershipBenefits() {

    const [content, setContent] = useState([
        {
            id: 1,
            title: "Exclusive Conference Discounts",
            content: "Full Members: Free registration at CANTO’s Annual Conference & Trade Exhibition, the premier telecom event of the Caribbean."
        },
        {
            id: 2,
            title: "Exclusive Conference Discounts",
            content: "Affiliate Members: 50% discount on the first participant’s registration at the Annual Conference & Trade Exhibition."
        },
        {
            id: 3,
            title: "For All Members - Exclusive Networking Opportunities",
            content: "Connect with government officials, telecom operators, vendors, regulators, and regional & international agencies."
        },
        {
            id: 4,
            title: "For All Members - Access to CANTO Events & Workshops",
            content: "Be a part of our high-level events and discussions shaping the future of Caribbean telecommunications."
        },
        {
            id: 5,
            title: "For All Members - Participation in CANTO's Working Committees",
            content: "Influence major areas including: Regulatory Affairs, Technology Trends, Marketing & Communications, Corporate Social Responsibility (CSR), Human Resources, Disaster Risk Management, Financial Advisory, Vendor/Supplier Relations."
        },
        {
            id: 6,
            title: "For All Members - Exclusive Access to the CANTO Annual Directory",
            content: "A comprehensive resource featuring key contacts in the ICT industry, including top decision-makers from regulators, operators, and vendors. This directory is an invaluable tool for networking and building relationships within the Caribbean telecommunications sector."
        }
    ])


  return (
    <div>  
        <div className='events-header-container' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/canto_benefits.jpg'})`}}>
            <div className='events-header-content'>
                <div className='events-header-title' style={{fontSize: '60px'}}>
                    The benefits of being a CANTO Member
                </div>
            </div>
        </div>

        <div className='membership-benefits-container'>
            { content.map((c, index) => {
                return (
                    <div style={{maxWidth: '60vh', marginBottom: '30px', lineHeight: '24px'}}>
                        <div style={{fontWeight: 'bold', fontSize: '20px', marginBottom: '12px'}}>{c.title}</div>
                        <div style={{color: '#9b9b9b'}}>{c.content}</div>


                    </div>
                )
            })

            }
        </div>
        
        <div className='membership-c2a-container'>
            For a full list of membership benefits, <div className='membership-c2a'>Click Here</div>
        </div>

        <div className='contact-form' style={{padding: '0 100px'}}>
            <div style={{marginBottom: '20px', fontSize: 24, fontWeight: 'bold'}}>Interested in becoming a CANTO member, please fill out the form below</div>
            <div className='contact-form-title'>Name</div>
            <input className='contact-form-input' type='text' placeholder='Enter your Name...'/>

            <div className='contact-form-title'>Email</div>
            <input className='contact-form-input' type='text' placeholder='Enter your E-mail...'/>

            <div className='contact-form-title'>Phone/Mobile number</div>
            <input className='contact-form-input' type='text' placeholder='Enter your Phone Number...'/>

            <div className='contact-form-title'>Message</div>
            <textarea className='contact-form-input area' placeholder=''/>

            <div className='contact-form-btn-container'>
                <div className='contact-form-btn'>
                    Send 
                    <div className='contact-form-btn-icon'>
                        <FaChevronRight size={16} color='#fff'/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
